import { isExpired } from "./tokenExpiry";

// localStorage key of the localhost login cache (dev login screen)
export const LOCAL_AUTH_CACHE_KEY = "__chatAuthCache__";

/**
 * Helper to get parent origin from URL query parameter
 */
export function getParentOriginFromUrl() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const parentOrigin = urlParams.get('parentOrigin');
    
    if (parentOrigin) {
      console.log('Parent origin from URL:', parentOrigin);
      return parentOrigin;
    }
    
    // Fallback: Try to detect from current origin (not recommended for production)
    console.warn('No parentOrigin in URL, using fallback detection');
    return window.location.origin.replace('chat.', '');
  } catch (error) {
    console.error('Error getting parent origin:', error);
    return null;
  }
}

/**
 * Helper to check if token is valid
 */
export function isTokenValid(tokenData) {
  if (!tokenData || !tokenData.AccessToken) return false;
  
  // Check if token has expired (if expires field exists)
  if (isExpired(tokenData.expires)) {
    console.log('Stored token has expired');
    return false;
  }
  
  return true;
}

/**
 * Try to load cached token from storage
 */
export function loadCachedToken() {
  try {
    const cachedToken = localStorage.getItem('__authTokenData__');
    if (cachedToken) {
      const tokenData = JSON.parse(cachedToken);
      if (isTokenValid(tokenData)) {
        console.log('Using cached token from localStorage');
        window.__authTokenData__ = tokenData;
        return true;
      } else {
        // Clear expired token
        localStorage.removeItem('__authTokenData__');
      }
    }
  } catch (error) {
    console.error('Error loading cached token:', error);
    localStorage.removeItem('__authTokenData__');
  }
  return false;
}

/**
 * Cache token in localStorage
 */
export function cacheToken(tokenData) {
  try {
    localStorage.setItem('__authTokenData__', JSON.stringify(tokenData));
    return true;
  } catch (error) {
    console.error('Error caching token:', error);
    return false;
  }
}

/**
 * Clear cached token from localStorage
 */
export function clearCachedToken() {
  try {
    localStorage.removeItem('__authTokenData__');
    return true;
  } catch (error) {
    console.error('Error clearing cached token:', error);
    return false;
  }
}

/**
 * Clear the localhost login cache from localStorage
 */
export function clearLocalAuthCache() {
  try {
    localStorage.removeItem(LOCAL_AUTH_CACHE_KEY);
    return true;
  } catch (error) {
    console.error('Error clearing local auth cache:', error);
    return false;
  }
}
